import loadable from '@loadable/component'

// Components
import CookieBar from 'components/cookiebar'

// Utils
import styles from './fixedfooter.css'

// Loadables
const Player = loadable(() => import('components/player'))

const FixedFooter = () => {
  return (
    <div className={styles.wrapper}>
      <Player />
      <CookieBar />
    </div>
  )
}

export default FixedFooter
